<template>
  <div id="app">
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>Bilet Gelir Dağılımı Raporu</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- <v-text-field flat="" solo-inverted="" hide-details v-model="search3" label=" Ara" append-icon="search"></v-text-field> -->
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html İndir</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel İndir</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>


          <v-container fluid>
            <v-card flat>
              <v-form ref="formdagrapor" v-model="valid" lazy-validation>
                <v-layout row wrap>
                  <v-flex xs12 sm12 md12>
                    <v-card flat>
                      <v-layout row wrap>
                        <v-flex pl-1 xs12 sm6 pt-1 md2>
                          <tarihcomp :etiket="'Başlangıç Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                            v-bind:defaultvalue="'ok'" v-bind:value="Rapor.BaslangicTarih" v-model="Rapor.BaslangicTarih"></tarihcomp>
                        </v-flex>

                        <v-flex xs12 pt-1 sm6 md2>
                          <tarihcomp :etiket="'Bitiş Tarihi'" :detaygizle="false" :rules="[v => !!v || 'Lütfen tarih seçiniz']"
                            v-bind:defaultvalue="'ok'" v-bind:value="Rapor.BitisTarih" v-model="Rapor.BitisTarih"></tarihcomp>
                        </v-flex>

                        <v-flex pt-1>
                          <v-layout>
                            <div v-if="load1">
                              <v-btn color="info" @click="getList()" fab small="" dark>
                                <v-icon>search</v-icon>
                              </v-btn>
                            </div>
                            <div v-if="progress">
                              <v-layout pt-3 align-center="">
                                <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                              </v-layout>
                            </div>
                            <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab" @click="filtrele()"
                              color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom="" :activator="el" v-model="tooltip">
                              <span>Arama Filtresi Ekle</span>
                            </v-tooltip>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-form>
            </v-card>
          </v-container>


          <v-container fluid="">
            <v-card flat>
              <v-layout row wrap>

                <!--
                  <v-flex xs12 sm12 md12>
                    <v-card>

                      <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="itemsana"
                        item-key="HavaYoluKodu" :search="search3">
                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <tr @click="props.expanded = !props.expanded">
                            <td class="text-xs-left">{{ props.item.Title }}</td>
                          </tr>
                        </template>
                        <template slot="expand" slot-scope="props">
                          <v-data-table hide-actions="" :headers="headersdetay" :items="props.item.List">
                            <template slot="items" slot-scope="props">
                              <tr style="background-color: lightgrey;" item>
                                <td class="text-xs-left">{{ props.item.labeller }}</td>
                                <td class="text-xs-left">{{ props.item.BiletTutari }}</td>
                                <td class="text-xs-left">{{ props.item.VergiTutari }}</td>
                                <td class="text-xs-left">{{ props.item.ToplamTutar }}</td>
                                <td class="text-xs-left">{{ props.item.KomisyonTutari }}</td>
                                <td class="text-xs-left">{{ props.item.ServisTutari }}</td>
                                <td class="text-xs-left">{{ props.item.ReserveTutari }}</td>
                                <td class="text-xs-left">{{ props.item.IskontoTutari }}</td>
                                <td class="text-xs-left">{{ props.item.Kar }}</td>
                                <td class="text-xs-left">{{ props.item.KarYuzde }}</td>
                                <td class="text-xs-left">{{ props.item.NetTutar }}</td>
                                <td class="text-xs-left">{{ props.item.SatisAdet }}</td>
                                <td class="text-xs-left">{{ props.item.IadeAdet }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </template>

                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                          Aradığınız "{{ search3 }}" kelimesi ile ilgili herhangi bir kayıt bulunamadı..
                        </v-alert>
                      </v-data-table>
                    </v-card>
                  </v-flex> -->


                <v-flex xs12 sm12 md12>
                  <template v-for="item in itemsana">

                    <v-layout row wrap v-bind:key="item.id">

                      <v-flex v-show="$vuetify.breakpoint.md || $vuetify.breakpoint.sm || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl "
                        xs12 sm12 md12>
                        <v-layout column="" fill-height="" row align-start>
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout align-center>
                                  <v-flex>
                                    <v-list-tile-sub-title>
                                      <v-layout column align-center>
                                        <v-flex v-if="item.tip== 'havayolu'" xs12 sm12 md12>
                                          <v-chip label color="white" text-color="pink">
                                            <v-icon color="pink" left>flight</v-icon> <span> {{item.Title}} </span>
                                          </v-chip>
                                        </v-flex>
                                        <v-flex v-if="item.tip== 'cari'" xs12 sm12 md12>
                                          <v-chip label color="white" text-color="pink">
                                            <v-icon color="pink" left>person</v-icon> <span> {{item.Title}} </span>
                                          </v-chip>
                                        </v-flex>

                                      </v-layout>
                                    </v-list-tile-sub-title>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                        </v-layout>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" xs12
                        sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout>

                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Bilet
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Tax
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Toplam
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Komisyon
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Servis
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Reserve
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  İskonto
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Kar
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  %
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Net
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md1>
                              <v-layout align-center="" justify-end="" fill-height="" row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="" row wrap>
                                    <span class="body-1 font-weight-">
                                      Satış
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 pr-1 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="" row wrap>
                                    <span class="body-1 font-weight-">
                                      İade
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-divider light></v-divider>

                          <v-layout>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.BiletTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.VergiTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.ToplamTutar | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.KomisyonTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.ServisTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.ReserveTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.IskontoTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.Kar | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.KarYuzde}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.ichat.NetTutar | moneyformat}} </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" row wrap justify-center="" fill-height="">
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="">

                                    <span class="caption font-weight-thin">
                                      {{item.ichat.SatisAdet}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 pr-1 sm6 md6>
                                  <v-layout align-center="" justify-end="">

                                    <span class="caption font-weight-thin">
                                      {{item.ichat.IadeAdet}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>

                          <v-divider light></v-divider>

                          <v-layout>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.BiletTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.VergiTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.ToplamTutar | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.KomisyonTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.ServisTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.ReserveTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.IskontoTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.Kar | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.KarYuzde}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.dishat.NetTutar | moneyformat}} </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" row wrap justify-center="" fill-height="">
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="">
                                    <span class="caption font-weight-thin">
                                      {{item.dishat.SatisAdet}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout pr-1 align-center="" justify-end="">

                                    <span class="caption font-weight-thin">
                                      {{item.dishat.IadeAdet}} &nbsp; </span>
                                  </v-layout>

                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>

                          <v-divider light></v-divider>

                          <v-layout>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.BiletTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.VergiTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.ToplamTutar | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.KomisyonTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.ServisTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.ReserveTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.IskontoTutari | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.Kar | moneyformat}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.KarYuzde}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{item.geneltoplam.NetTutar | moneyformat}} </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" row wrap justify-center="" fill-height="">
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="">

                                    <span class="caption font-weight-thin">
                                      {{item.geneltoplam.SatisAdet}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 pr-1 sm6 md6>
                                  <v-layout align-center="" justify-end="">

                                    <span class="caption font-weight-thin">
                                      {{item.geneltoplam.IadeAdet}} &nbsp; </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>

                        </v-card>
                      </v-flex>


                      <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout row wrap>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Bilet Tutarı
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      İç Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.BiletTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Dış Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.BiletTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Toplam:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.BiletTutari}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Tax
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      İç Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.VergiTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Dış Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.VergiTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Toplam:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.VergiTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Toplam
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      İç Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.ToplamTutar | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Dış Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.ToplamTutar | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Toplam:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.ToplamTutar | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Komisyon
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      İç Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.KomisyonTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Dış Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.KomisyonTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Toplam:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.KomisyonTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Servis
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      İç Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.ServisTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Dış Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.ServisTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Toplam:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.ServisTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Reserve
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      İç Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.ReserveTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Dış Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.ReserveTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Toplam:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.ReserveTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> İskonto
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      İç Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.IskontoTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Dış Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.IskontoTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Toplam:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.IskontoTutari | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Kar
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      İç Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.Kar | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Dış Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.Kar | moneyformat }}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Toplam:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.Kar | moneyformat }}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Yuzde %
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      İç Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.KarYuzde}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Dış Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.KarYuzde}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Toplam:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.KarYuzde}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Net
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      İç Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.NetTutar | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Dış Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.NetTutar | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Toplam:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.NetTutar | moneyformat}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold">
                                  Satış Adet
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      İç Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.SatisAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Dış Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.SatisAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Toplam:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.SatisAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>


                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold">
                                  İade Adet
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      İç Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.ichat.IadeAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Dış Hat:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.dishat.IadeAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-start="" fill-height="">
                                    <span class="subheading font-weight-">
                                      Toplam:
                                    </span>
                                  </v-layout>
                                </v-flex>
                                <v-flex xs6 sm6 md6>
                                  <v-layout align-center="" justify-end="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{item.geneltoplam.IadeAdet}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                    </v-layout>
                    <v-divider :key="item.id"></v-divider>
                  </template>


                </v-flex>


                <v-layout row wrap>
                  <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" ma-2
                    xs12 sm12 md12>
                    <v-layout align-center="" justify-center="" fill-height="">
                      <span class="title grey--text font-weight-bold">
                        Genel Toplamlar
                      </span>
                    </v-layout>
                  </v-flex>

                  <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" xs12
                    sm12 md12>
                    <v-card flat="" class="grey--text">
                      <v-layout>

                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              Bilet
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              Tax
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              Toplam
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              Komiyon
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              Servis
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              Reserve
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              İskonto
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              Kar
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              %
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="body-1 font-weight-">
                              Net
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs2 sm2 md1>
                          <v-layout align-center="" justify-end="" fill-height="" row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="" row wrap>
                                <span class="body-1 font-weight-">
                                  Satış
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 pr-1 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="" row wrap>
                                <span class="body-1 font-weight-">
                                  İade
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-divider light></v-divider>

                      <v-layout>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-">
                              İç Hat:
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.BiletTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.VergiTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.ToplamTutar}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.KomisyonTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.ServisTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.ReserveTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.IskontoTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.Kar}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.KarYuzde}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{genic.NetTutar}} </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" row wrap justify-center="" fill-height="">
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="">

                                <span class="caption font-weight-thin">
                                  {{genic.SatisAdet}} &nbsp; </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 pr-1 sm6 md6>
                              <v-layout align-center="" justify-end="">

                                <span class="caption font-weight-thin">
                                  {{genic.IadeAdet}} &nbsp; </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <v-divider light></v-divider>

                      <v-layout>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-">
                              Dış Hat:
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.BiletTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.VergiTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.ToplamTutar}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.KomisyonTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.ServisTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.ReserveTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.IskontoTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.Kar}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.KarYuzde}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gendis.NetTutar}} </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" row wrap justify-center="" fill-height="">
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="">
                                <span class="caption font-weight-thin">
                                  {{gendis.SatisAdet}} &nbsp; </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 pr-1 sm6 md6>
                              <v-layout align-center="" justify-end="">

                                <span class="caption font-weight-thin">
                                  {{gendis.IadeAdet}} &nbsp; </span>
                              </v-layout>

                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <v-divider light></v-divider>

                      <v-layout>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-">
                              Toplam:
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.BiletTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.VergiTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.ToplamTutar}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.KomisyonTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.ServisTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.ReserveTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.IskontoTutari}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.Kar}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.KarYuzde}}
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" justify-end="" fill-height="">
                            <span class="caption font-weight-thin">
                              {{gengen.NetTutar}} </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs1 sm1 md1>
                          <v-layout align-center="" row wrap justify-center="" fill-height="">
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="">

                                <span class="caption font-weight-thin">
                                  {{gengen.SatisAdet}} &nbsp; </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 pr-1 sm6 md6>
                              <v-layout align-center="" justify-end="">

                                <span class="caption font-weight-thin">
                                  {{gengen.IadeAdet}} &nbsp; </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                    </v-card>
                  </v-flex>

                  <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                    <v-card class="grey--text">
                      <v-layout row wrap>

                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <v-chip color="green"> <span class="subheading white--text"> Genel Toplamlar
                              </span>
                            </v-chip>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> Bilet Tutarı
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.BiletTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.BiletTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.BiletTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> Tax
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.VergiTutari}}
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.VergiTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.VergiTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> Toplam
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.ToplamTutar}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.ToplamTutar}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.ToplamTutar}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> Komisyon
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.KomisyonTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.KomisyonTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.KomisyonTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> Servis
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.ServisTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.ServisTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.ServisTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> Reserve
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.ReserveTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.ReserveTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.ReserveTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> İskonto
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.IskontoTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.IskontoTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.IskontoTutari}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> Kar
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.Kar}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.Kart}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.Kar}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> Yuzde %
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.KarYuzde}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.KarYuzde}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.KarYuzde}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold"> Net
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.NetTutar}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.NetTutar}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.NetTutar}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold">
                              Satış Adet
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.SatisAdet}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.SatisAdet}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.SatisAdet}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm12 md12>
                          <v-divider light></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout align-center="" justify-center="" fill-height="">
                            <span class="subheading grey--text font-weight-bold">
                              İade Adet
                            </span>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  İç Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{genic.IadeAdet}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Dış Hat:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gendis.IadeAdet}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout row wrap>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-start="" fill-height="">
                                <span class="subheading font-weight-">
                                  Toplam:
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs6 sm6 md6>
                              <v-layout align-center="" justify-end="" fill-height="">
                                <span class="subheading font-weight-thin">
                                  {{gengen.IadeAdet}}
                                </span>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-flex>



                      </v-layout>




                    </v-card>
                  </v-flex>

                </v-layout>


                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
                  :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                  {{ text1 }}
                  <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                </v-snackbar>
                <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="450px">
                  <v-card color="grey lighten-2">
                    <v-card-title>Filtre Seçimi</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                      <v-layout row="" wrap="">
                        <div class="flex md12">
                          <v-radio-group v-model="Rapor.HavayoluCari" hide-details>
                            <v-radio :value="false" label="Hava Yolu Gelir Dağılım Raporu"></v-radio>
                            <v-radio :value="true" label="Müşteri Gelir Dağılım Raporu"></v-radio>
                          </v-radio-group>
                        </div>
                        <div class="flex md12">
                          <v-autocomplete v-show="hygelir" hide-details="" tabindex="2" v-model="Rapor.HavaYoluKodu"
                            :items="itemsairlinelist" clearable item-text="HavaYoluAdi" item-value="HavaYoluKodu" label="Hava Yolu Kodu"></v-autocomplete>
                          <v-autocomplete v-show="musterigelir" hide-details="" clearable="" v-model="Rapor.CariKodu"
                            label="Müşteri Seçiniz" append-icon="search" :loading="loading" :items="statecari"
                            item-text="text" cache-items="" item-value="id" :search-input.sync="searchcari">
                          </v-autocomplete>
                          <v-layout>
                            <v-select :items="hesapgurubu" hide-details="" multiple="" v-model="Rapor.IstenilenHesapGrub"
                              label="İstenilen Hesap Gurubu" item-text="Adi" item-value="Kod" max-height="400"></v-select>
                            <v-select :items="hesapgurubu" hide-details="" multiple="" v-model="Rapor.IstenmeyenHesapGrub"
                              label="İstenmeyen Hesap Gurubu" item-text="Adi" item-value="Kod" max-height="400"></v-select>
                          </v-layout>

                          <v-autocomplete v-show="musterigelir" hide-details="" clearable="" v-model="Rapor.AnaHesap"
                            label="Ana Hesap Seçiniz" append-icon="search" :loading="loading" :items="statecari1"
                            item-text="text" cache-items="" item-value="id" :search-input.sync="searchcari1">
                          </v-autocomplete>
                          <v-autocomplete hide-details="" v-model="Rapor.Masraf" :items="masrafmerkezi" label="Masraf Merkezi"
                            item-text="CodeName" clearable item-value="Code" max-height="400"></v-autocomplete>
                        </div>
                        <div class="flex md12">
                          <div class="card__text grey darken-1 white--text">
                            <h3>Opsiyonlar</h3>
                          </div>
                          <v-checkbox label="Alış Servisi Servisten Çıkar" hide-details="" v-model="Rapor.AlisServisDus"
                            vhide-details=""></v-checkbox>
                          <v-checkbox label="KDV Düşülmüş" v-model="Rapor.KdvDusulmus" hide-details=""></v-checkbox>
                          <v-checkbox label="Özet" v-model="Rapor.DetayOzet" hide-details=""></v-checkbox>
                          <v-checkbox v-model="tumsirketler" label="Tüm Şirketler" hide-details=""></v-checkbox>
                        </div>
                      </v-layout>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-btn color="blue darken-1" flat @click.native="filtreiptal()">İptal</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="filtrekayit()">Fİltrelerİ Uygula</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-layout>
            </v-card>
          </v-container>


        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../api/auth'
  import tarihcomp from '../customcomp/tarihim'
  import helpers from "@/components/app/customcomp/helpers.js"


  export default {
    data() {
      return {

        satisIc: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        satisDis: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },

        satisGen: {
          BiletTutari: 0,
          CezaTutari: 0,
          VergiTutari: 0,
          IskontoTutari: 0,
          ServisTutari: 0,
          IadeServisTutari: 0,
          ReserveTutari: 0,
          KrediliTutar: 0,
          PesinTutar: 0,
          RKartliTutar: 0,
          CKartliTutar: 0,
          FKartliTutar: 0,

        },





















        search: '',
        headers: [{
          text: 'Hava Yolu Bilgisi',
          value: 'Title'
        }],


        headersdetay: [{
            text: 'Bilet Tip',
            value: 'labeller',
            width: "1%",
            class: "background-color:red;"
          },
          {
            text: 'Bilet',
            value: 'BiletTutari'
          },
          {
            text: 'Tax',
            value: 'VergiTutari'
          },
          {
            text: 'Toplam',
            value: 'ToplamTutar'
          },
          {
            text: 'Komisyon',
            value: 'KomisyonTutari'
          },
          {
            text: 'Servis',
            value: 'ServisTutari'
          },
          {
            text: 'Reserve',
            value: 'ReserveTutari'
          },
          {
            text: 'İskonto',
            value: 'IskontoTutari'
          },
          {
            text: 'Kar',
            value: 'Kar'
          },
          {
            text: 'Yuzde',
            value: 'KarYuzde'
          },
          {
            text: 'Net',
            value: 'NetTutar'
          },
          {
            text: 'Satış Adet',
            value: 'SatisAdet'
          },
          {
            text: 'IadeAdet',
            value: 'IadeAdet'
          }
        ],

        genic: {
          BiletTutari: 0,
          VergiTutari: 0,
          ToplamTutar: 0,
          KomisyonTutari: 0,
          ServisTutari: 0,
          ReserveTutari: 0,
          IskontoTutari: 0,
          Kar: 0,
          KarYuzde: 0,
          NetTutar: 0,
          SatisAdet: 0,
          IadeAdet: 0
        },

        gendis: {
          BiletTutari: 0,
          VergiTutari: 0,
          ToplamTutar: 0,
          KomisyonTutari: 0,
          ServisTutari: 0,
          ReserveTutari: 0,
          IskontoTutari: 0,
          Kar: 0,
          KarYuzde: 0,
          NetTutar: 0,
          SatisAdet: 0,
          IadeAdet: 0

        },

        gengen: {
          BiletTutari: 0,
          VergiTutari: 0,
          ToplamTutar: 0,
          KomisyonTutari: 0,
          ServisTutari: 0,
          ReserveTutari: 0,
          IskontoTutari: 0,
          Kar: 0,
          KarYuzde: 0,
          NetTutar: 0,
          SatisAdet: 0,
          IadeAdet: 0

        },


        valid: true,
        itemsana: [],
        Rapor: {
          HavayoluCari: false,
          SirketKodu: null,
          KesenKisi: null,
          CariKodu: null,
          HavaYoluKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          AnaHesap: null,
          IstenilenHesapGrub: [],
          IstenmeyenHesapGrub: [],
          Masraf: null,
          KdvDusulmus: false,
          DetayOzet: false,
          AlisServisDus: false
        },

        itemsairlinelist: [],
        hesapgurubu: [],
        masrafmerkezi: [],
        doviztipi: [],
        hygelir: false,
        musterigelir: false,
        tumsirketler: '',
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        moneyformatted: '',
        date2: null,
        menu2: false,
        moneyformatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',

        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        statecari1: [],
        searchcari: '',
        progress: false,
        searchcari1: null,
        yok: false,
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        tooltip: false,
        el: null,
      }
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el
    },

    components: {
      'tarihcomp': tarihcomp
    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      },

      'Rapor.HavayoluCari': function () {
        if (this.Rapor.HavayoluCari == true) {
          this.hygelir = false
          this.musterigelir = true
          this.Rapor.HavaYoluKodu = null
        } else {
          this.musterigelir = false
          this.hygelir = true
          this.Rapor.CariKodu = null
          this.Rapor.AnaHesap = null
        }
      },
      searchcari1(val) {
        val && this.carigetir1(val)
      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },
    methods: {
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
      carigetir: carigetir,
      carigetir1: carigetir1

    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.itemsairlinelist = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.progress = false

        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.hesapgurubu = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })


  }




  function filtrekayit() {
    this.dialogfiltre = false
  }

  function filtreiptal() {
    this.Rapor.HavayoluCari = false;
    this.Rapor.SirketKodu = null;
    this.Rapor.KesenKisi = null;
    this.Rapor.AlisServisDus = false,
      this.Rapor.CariKodu = null;
    this.Rapor.HavaYoluKodu = null;
    this.Rapor.AnaHesap = null;
    this.Rapor.Masraf = null;
    this.Rapor.KdvDusulmus = false;
    this.Rapor.DetayOzet = false;
    this.dialogfiltre = false;
    this.tumsirketler = false;
  }


  function carigetir(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function carigetir1(v) {
    if (v.length >= 0) {
      this.loading = true
      setTimeout(() => {
        this.$http.post(auth.API_URL + 'api/options/CurrentSearch', {
          q: escape(v)
        }, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.statecari1 = response.body
          this.Error = false
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })
        this.loading = false
      }, 500)
    }
  }

  function getList() {
    if (this.$refs.formdagrapor.validate()) {

      var bastarih = new Date(this.Rapor.BaslangicTarih)
      var bittarih = new Date(this.Rapor.BitisTarih)

      if (bastarih <= bittarih) {

        this.progress = true
        this.load1 = false
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        if (this.tumsirketler === true) {
          this.Rapor.SirketKodu = '0'
        } else {
          this.Rapor.SirketKodu = credentials.SirketKodu
        }


        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketReport/IncomeDistReport', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.itemsana = [];

          if (response.body.Detay.length > 0) {

            response.body.Detay.forEach(element => {
              // var ListHavaYolu = [];
              var yenihavayoluyedek = [];



              var ichat = {

                BiletKarYuzde: element.DetayIcHatToplamlar.KarYuzde,
                BiletTutari: element.DetayIcHatToplamlar.BiletTutari,
                IadeAdet: element.DetayIcHatToplamlar.IadeAdet,
                IskontoTutari: element.DetayIcHatToplamlar.IskontoTutari,
                Kar: element.DetayIcHatToplamlar.Kar,
                KarYuzde: element.DetayIcHatToplamlar.KarYuzde,
                KomisyonTutari: element.DetayIcHatToplamlar.KomisyonTutari,
                NetTutar: element.DetayIcHatToplamlar.NetTutar,
                ReserveTutari: element.DetayIcHatToplamlar.ReserveTutari,
                SatisAdet: element.DetayIcHatToplamlar.SatisAdet,
                ServisTutari: element.DetayIcHatToplamlar.ServisTutari,
                ToplamTutar: element.DetayIcHatToplamlar.ToplamTutar,
                VergiTutari: element.DetayIcHatToplamlar.VergiTutari,
              }

              var dishat = {

                BiletKarYuzde: element.DetayDisHatToplamlar.KarYuzde,
                BiletTutari: element.DetayDisHatToplamlar.BiletTutari,
                IadeAdet: element.DetayDisHatToplamlar.IadeAdet,
                IskontoTutari: element.DetayDisHatToplamlar.IskontoTutari,
                Kar: element.DetayDisHatToplamlar.Kar,
                KarYuzde: element.DetayDisHatToplamlar.KarYuzde,
                KomisyonTutari: element.DetayDisHatToplamlar.KomisyonTutari,
                NetTutar: element.DetayDisHatToplamlar.NetTutar,
                ReserveTutari: element.DetayDisHatToplamlar.ReserveTutari,
                SatisAdet: element.DetayDisHatToplamlar.SatisAdet,
                ServisTutari: element.DetayDisHatToplamlar.ServisTutari,
                ToplamTutar: element.DetayDisHatToplamlar.ToplamTutar,
                VergiTutari: element.DetayDisHatToplamlar.VergiTutari,
              }

              var geneltoplam = {

                BiletKarYuzde: element.DetayGenelHatToplamlar.KarYuzde,
                BiletTutari: element.DetayGenelHatToplamlar.BiletTutari,
                IadeAdet: element.DetayGenelHatToplamlar.IadeAdet,
                IskontoTutari: element.DetayGenelHatToplamlar.IskontoTutari,
                Kar: element.DetayGenelHatToplamlar.Kar,
                KarYuzde: element.DetayGenelHatToplamlar.KarYuzde,
                KomisyonTutari: element.DetayGenelHatToplamlar.KomisyonTutari,
                NetTutar: element.DetayGenelHatToplamlar.NetTutar,
                ReserveTutari: element.DetayGenelHatToplamlar.ReserveTutari,
                SatisAdet: element.DetayGenelHatToplamlar.SatisAdet,
                ServisTutari: element.DetayGenelHatToplamlar.ServisTutari,
                ToplamTutar: element.DetayGenelHatToplamlar.ToplamTutar,
                VergiTutari: element.DetayGenelHatToplamlar.VergiTutari,
              }

              if (element.Havayolu != null) {
                yenihavayoluyedek = {
                  tip:'havayolu',
                  HavaYoluKodu: element.Havayolu.HavaYoluKodu,
                  HavaYoluAdi: element.Havayolu.HavaYoluAdi,
                  Title: element.Havayolu.HavaYoluKodu + '-' + element.Havayolu.HavaYoluAdi,
                  ichat: ichat,
                  dishat: dishat,
                  geneltoplam: geneltoplam
                }
              } else if (element.Cari != null) {
                yenihavayoluyedek = {
                  tip:'cari',
                  HavaYoluKodu: element.Cari.Kod,
                  HavaYoluAdi: element.Cari.Unvan,
                  Title: element.Cari.Kod + '-' + element.Cari.Unvan,
                  ichat: ichat,
                  dishat: dishat,
                  geneltoplam: geneltoplam
                }


                // List: []
              };

              // ListHavaYolu.push(ichat);
              //ListHavaYolu.push(dishat);
              //  ListHavaYolu.push(geneltoplam);
              // yenihavayoluyedek.List = ListHavaYolu;
              this.itemsana.push(yenihavayoluyedek);

            });

            console.log('anatiem' + this.itemsana)

            this.genic.BiletTutari = response.body.IcHatToplamlar.BiletTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.VergiTutari = response.body.IcHatToplamlar.VergiTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.ToplamTutar = response.body.IcHatToplamlar.ToplamTutar.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.KomisyonTutari = response.body.IcHatToplamlar.KomisyonTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.ServisTutari = response.body.IcHatToplamlar.ServisTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.ReserveTutari = response.body.IcHatToplamlar.ReserveTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.IskontoTutari = response.body.IcHatToplamlar.IskontoTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.Kar = response.body.IcHatToplamlar.Kar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            this.genic.KarYuzde = response.body.IcHatToplamlar.KarYuzde;
            this.genic.NetTutar = response.body.IcHatToplamlar.NetTutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
              '$1,');
            this.genic.SatisAdet = response.body.IcHatToplamlar.SatisAdet
            this.genic.IadeAdet = response.body.IcHatToplamlar.IadeAdet

            this.gendis.BiletTutari = response.body.DisHatToplamlar.BiletTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.VergiTutari = response.body.DisHatToplamlar.VergiTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.ToplamTutar = response.body.DisHatToplamlar.ToplamTutar.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.KomisyonTutari = response.body.DisHatToplamlar.KomisyonTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.ServisTutari = response.body.DisHatToplamlar.ServisTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.ReserveTutari = response.body.DisHatToplamlar.ReserveTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.IskontoTutari = response.body.DisHatToplamlar.IskontoTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.Kar = response.body.DisHatToplamlar.Kar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gendis.KarYuzde = response.body.DisHatToplamlar.KarYuzde;
            this.gendis.NetTutar = response.body.DisHatToplamlar.NetTutar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
              '$1,');
            this.gendis.SatisAdet = response.body.DisHatToplamlar.SatisAdet
            this.gendis.IadeAdet = response.body.DisHatToplamlar.IadeAdet

            this.gengen.BiletTutari = response.body.GenelHatToplamlar.BiletTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.VergiTutari = response.body.GenelHatToplamlar.VergiTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.ToplamTutar = response.body.GenelHatToplamlar.ToplamTutar.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.KomisyonTutari = response.body.GenelHatToplamlar.KomisyonTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.ServisTutari = response.body.GenelHatToplamlar.ServisTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.ReserveTutari = response.body.GenelHatToplamlar.ReserveTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.IskontoTutari = response.body.GenelHatToplamlar.IskontoTutari.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.Kar = response.body.GenelHatToplamlar.Kar.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            this.gengen.KarYuzde = response.body.GenelHatToplamlar.KarYuzde;
            this.gengen.NetTutar = response.body.GenelHatToplamlar.NetTutar.toFixed(2).replace(
              /(\d)(?=(\d{3})+\.)/g,
              '$1,');
            this.gengen.SatisAdet = response.body.GenelHatToplamlar.SatisAdet
            this.gengen.IadeAdet = response.body.GenelHatToplamlar.IadeAdet


          } else {

            this.text1 = 'Kayıt Bulanamadı.'
            this.snackbar = true

          }
          this.progress = false
          this.load1 = true

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
      } else {
        this.text1 = 'Başlangıç tarihi bitiş tarihinden büyük olamaz...'
        this.snackbar = true
      }
    }
  }

  function getListHtml() {

    if (this.$refs.formdagrapor.validate()) {

      this.progress = true
      this.load1 = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }


      var params = this.Rapor

      this.$http
        .post(auth.API_URL + "api/TicketReport/IncomeDistReportHtml", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "GelirDagilim.html";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
    }
  }

  function getListExcel() {


    if (this.$refs.formdagrapor.validate()) {

      this.progress = true
      this.load1 = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }


      var params = this.Rapor

      this.$http
        .post(auth.API_URL + "api/TicketReport/IncomeDistReportExcel", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "GelirDagilim.xlsx";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
    }
  }

  function beforeMount() {

  }
</script>
<style>
</style>